
<template>
  <div
    class="col margin16"
    style="background-color: #fdfdfd;"
  >
    <ToolbarCalendar
      @open-to-edit="handlerClickAppointment"
      @update-schedule="updateSchedule"
    />

    <FullCalendar
      ref="calendar"
      :options="calendarOptions"
    />

    <q-dialog
      v-model="editSchedule"
      class="white-backdrop"
    >
      <DetailsAppointment
        :event-details="eventDetails"
        :is-paused="agent.paused"
        @close-card="handleEditSchedule"
        :agent-id="this.agent.id"
      />
    </q-dialog>

    <q-dialog
      v-model="showScheduleCard"
    >
      <div>
        <CardSchedule
          :agent-id="this.agent.id"
          :date="dateSelected"
          :attendance="attendance"
          :is-paused="agent.paused"
          @close-calendar="cleanAttendance"
        />
      </div>
    </q-dialog>

    <q-separator />
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'

import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from '@fullcalendar/timegrid'
import DetailsAppointment from '@/components/DetailsAppointment'
import moment from 'moment-timezone'
import { mapGetters, mapState } from 'vuex'
import CardSchedule from '@/components/CardSchedule.vue'
import ToolbarCalendar from '@/components/ToolbarCalendar'
moment.locale('pt-br')

export default {
  components: {
    DetailsAppointment,
    FullCalendar,
    CardSchedule,
    ToolbarCalendar
  },

  data () {
    return {
      eventDetails: {},
      calendarOptions: this.handleCalendarOptions(),
      appointment: { title: '', date: null, time: null },
      showScheduleCard: false,
      dateSelected: '',
      editSchedule: false,
      attendance: null,
      onlyCreate: false,
      timeSelected: '',
      showNotifications: false

    }
  },

  mounted () {
    this.calendarOptions.events = this.events
    this.attendance = this.$route.query?.attendance
    this.onlyCreate = this.$route.query?.onlyCreate

    const notificationMode = this.$store.getters['calendarModule/notificationMode']
    this.showNotifications = notificationMode

    this.$nextTick(this.updateCustomButtonIcon)
    this.$nextTick(this.closeCalendar)
  },

  computed: {
    ...mapGetters({ agent: 'agentModule/getAgent' }),
    ...mapState({ events: (state) => state.calendarModule.appointments })

  },

  methods: {

    cleanAttendance () {
      this.attendance = null
      this.onlyCreate = false
      this.showScheduleCard = false
    },
    handleCalendarOptions () {
      return {
        allDayText: 'Dia Inteiro',
        aspectRatio: 1.2,
        headerToolbar: false,
        dateClick: this.toogleScheduleCard,
        displayEventTime: true,
        eventClick: this.handlerClickAppointment,
        eventTextColor: '#000',
        events: [],
        handleWindowResize: true,
        height: '82vh',
        locale: 'pt-br',
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
        selectable: true,
        slotDuration: '00:30:00',
        slotLabelInterval: { minutes: 30 },
        slotLabelFormat: {
          hour: '2-digit',
          minute: '2-digit',
          omitZeroMinute: false,
          meridiem: 'short'
        },
        timeZone: 'local',
        titleFormat: { year: 'numeric', month: 'numeric' }
      }
    },

    handlerClickAppointment (info) {
      if (this.onlyCreate) return
      const { start, end, id, title, allDay, extendedProps, backgroundColor } = info?.event ?? info
      const { attendanceInfo, configs, contact } = extendedProps

      const parsedConfigs = parseVar(configs)

      const formatDate = allDay ? 'DD/MM/YY' : 'DD/MM/YY HH:mm'

      this.eventDetails = {
        id,
        agentId: this.agent.id,
        title,
        description: parsedConfigs?.description,
        contact,
        notificationTimeBefore: parsedConfigs?.notificationTimeBefore,
        templateToSend: parsedConfigs?.templateToSend,
        date: moment(start).format(formatDate),
        start,
        end,
        attendanceInfo,
        backgroundColor
      }

      this.editSchedule = true
    },

    handleEditSchedule (events) {
      this.editSchedule = false
      if (events) this.calendarOptions.events = events
    },

    updateSchedule (events) {
      if (events) this.calendarOptions.events = events
    },

    onClickOutsideDialog () {
      this.editSchedule = false
    },

    toogleScheduleCard (info) {
      const calendarApi = info.view.calendar
      if (info.view.type !== 'timeGridDay') return calendarApi.changeView('timeGridDay', info.dateStr)
      this.dateSelected = info.dateStr
      this.showScheduleCard = true
    },

    renderEventContent (info) {
      const icon = 'mdi-calendar-alert'

      return {
        html: `<div style="display:flex;align-items:center; width: 100%;">
               <i class="calendar-icon mdi ${icon}" style="margin-right:2px; color:${info.backgroundColor};style="text-overflow: ellipsis;"></i>
               <span style="text-overflow: ellipsis;width: 100%;overflow: hidden;">${info.event.title}</span>
             </div>`
      }
    },

    toggleSpecial () {
      this.showNotifications = !this.showNotifications
      this.updateCustomButtonIcon()
      this.$store.dispatch('calendarModule/showNotifications', { notificationMode: this.showNotifications })
      let message = 'Notificações desativadas'
      if (this.showNotifications) message = 'Notificações ativadas'

      this.$q.notify({
        message,
        color: '#fff',
        position: 'top',
        timeout: 1000,
        textColor: 'black',
        closeBtn: true,
        classes: 'notification-popup',
        progress: true
      })
    },

    updateCustomButtonIcon () {
      const btn = document.querySelector('.fc-toggleSpecialMode-button')
      if (btn) {
        btn.innerHTML = `<i class="mdi ${this.showNotifications ? 'mdi-bell-outline' : 'mdi-bell-off-outline'}"></i>`
        btn.style.border = '1px solid #d9d9d9'
        btn.style.padding = '0'
        btn.style.width = '40px'
        btn.style.boxShadow = 'none'
        btn.style.color = 'black'
      }
    },

    closeCalendar () {
      const btn = document.querySelector('.fc-closePopup-button')
      if (btn) {
        btn.innerHTML = '<i class="mdi mdi-close"></i>'
        btn.style.border = '1px solid #d9d9d9'
        btn.style.padding = '0'
        btn.style.width = '40px'
        btn.style.boxShadow = 'none'
        btn.style.color = 'black'
      }
    }

  }

}

const parseVar = (e) => {
  if (!e) return {}

  try {
    return JSON.parse(e)
  } catch {
    return e
  }
}

</script>

<style lang="sass">
.margin16
  margin: 8px
.fc .fc-toolbar.fc-header-toolbar
  margin-bottom: 8px
.fc-toolbar-chunk
  display: flex
  height: 40px
  align-items: center
  justify-content: space-between

.fc .fc-button
  background-color: #fff
  border: 1px solid #d9d9d9
  color: #333
  border-radius: 8px
  padding: 7px

.fc .fc-button:hover

  border: 1px solid #d9d9d9
  box-shadow: none

.fc .fc-button-primary:disabled
  background-color: grey
  border: 1px solid #d9d9d9

.fc .fc-button-primary:not(:disabled).fc-button-active:focus, .fc .fc-button-primary:not(:disabled):active:focus
  box-shadow: none
  border: 1px solid #d9d9d9

.fc .fc-button-primary:not(:disabled).fc-button-active, .fc .fc-button-primary:not(:disabled):active
  border: 1px solid #d9d9d9

.fc .fc-button-primary:not(:disabled):active
  background-color: #fff

.fc fc-button:focus
  box-shadow: none
  border: 1px solid #d9d9d9

.fc .fc-button-primary:focus
  box-shadow: none
  border: 1px solid #d9d9d9

.fc .fc-button-primary:hover
  border: 1px solid black
  background-color: #fff
  color: black

.fc .fc-toolbar
  padding-bottom: 8px
  border-bottom: 1px solid #d9d9d9
  color: #333
  font-weight: bold

.fc-timegrid-slot
  cursor: pointer

.fc-day
  cursor: pointer

.fc-col-header-cell
  background-color: #f2f2f2
.fc-daygrid-day
  background-color: #fdfdfd

.notification-popup
  background-color: white
  border: 1px solid #d9d9d9
  border-radius: 20px
</style>
